import clsx from 'clsx';

export function Spinner({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <span
      role="status"
      aria-label="Carregando"
      style={{ width: size, height: size }}
      className={clsx(
        'inline-block rounded-full border-2 border-current border-t-transparent animate-spin',
        className,
      )}
    />
  );
}
